import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorInstanceBuildingHasFloors } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_instance_building_has_floors';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'fpni.id',
    'fpni.fpnInstanceHasBuildingId',
    'fpni.fpnInstanceFloorId',
    'fpni.floorNumber',
  ],
  limit: 'false',
  alias: 'fpni',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpni',
  relations: [],
  select: [
    'fpni.id',
    'fpni.fpnInstanceHasBuildingId',
    'fpni.fpnInstanceFloorId',
    'fpni.floorNumber',
  ],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInstanceBuildingHasFloors>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
